<section>
  <app-welcome-navbar />
  <div
    class="h-screen overflow-hidden bg-[url('/img/bo-bg-2.webp')] bg-cover bg-center px-5 sm:px-10 lg:px-0">
    <div class="grid grid-cols-3 lg:grid-cols-6">
      <!-- Formulario de login -->
      <div
        class="col-span-3 flex h-screen items-center lg:col-span-2 lg:-me-15 lg:ps-10 xl:me-0 xl:ps-0">
        <div class="mx-auto w-sm">
          <app-form-login />
        </div>
      </div>

      <!-- Imagen del carro -->
      <div
        class="col-span-3 hidden h-screen items-end overflow-hidden lg:relative lg:col-span-4 lg:flex">
        <!-- Text Cards -->
        <div
          class="absolute z-10 grid h-full w-full grid-cols-1 px-5 py-40 sm:px-25 sm:py-30 lg:py-0">
          <!-- Column Top -->
          <div
            class="col-span-1 flex flex-col items-center gap-5 lg:items-start lg:justify-around lg:gap-0">
            <div class="flex flex-col gap-5 lg:flex-row lg:gap-0">
              <div
                class="flex h-fit max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md">
                <h2 class="text-[11px] font-semibold text-white">
                  Administra tu plataforma de vehículos desde un solo lugar
                </h2>
                <p class="max-w-md text-[10px] text-white">
                  Administra cada aspecto de tu aplicación de vehículos con una
                  plataforma intuitiva y centralizada. Desde el manejo de
                  usuarios hasta la configuración de financiamientos, aquí
                  encontrarás todas las herramientas que necesitas para operar
                  de forma eficiente.
                </p>
              </div>
              <div
                class="h-fit max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md sm:flex lg:-translate-x-10 lg:translate-y-22">
                <h2 class="text-[11px] font-semibold text-white">
                  El centro de control para tu ecosistema automotriz
                </h2>
                <p class="max-w-md text-[10px] text-white">
                  Simplifica tu trabajo diario con un panel que te permite
                  controlar vehículos, planes, clientes y procesos desde un
                  único sitio. Todo diseñado para que crezcas sin perder tiempo.
                </p>
              </div>
            </div>
          </div>
          <!-- Column Bottom -->
          <div
            class="col-span-1 flex flex-col items-center gap-5 lg:items-start lg:justify-around lg:gap-0">
            <div class="flex flex-col gap-5 lg:flex-row lg:gap-0">
              <div
                class="flex h-fit max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md">
                <h2 class="text-[11px] font-semibold text-white">
                  Tu backoffice para una administración rápida y eficiente
                </h2>
                <p class="max-w-sm text-[10px] text-white">
                  Nuestro panel centralizado te permite mantener el control
                  total de tu operación, optimizar tiempos y asegurar que cada
                  dato esté siempre actualizado. Todo en un entorno intuitivo,
                  seguro y preparado para acompañar el crecimiento de tu negocio
                  automotriz.
                </p>
              </div>
              <div
                class="h-fit max-w-lg flex-col gap-2 rounded-md border border-white/10 bg-white/10 px-5 py-3 backdrop-blur-md sm:flex lg:translate-x-10 lg:translate-y-25">
                <h2 class="text-[11px] font-semibold text-white">
                  Control Total de Usuarios
                </h2>
                <p class="max-w-sm text-[10px] text-white">
                  Mantén un registro organizado de clientes, administradores y
                  colaboradores, revisa su actividad, actualiza información en
                  segundos y garantiza que cada usuario tenga el nivel de acceso
                  adecuado.
                </p>
              </div>
            </div>
          </div>
        </div>
        <img
          src="/img/welcome-car.webp"
          alt="Haval Jolion"
          class="absolute -right-120 bottom-20 scale-140 md:scale-130 lg:-right-50 xl:bottom-5" />
      </div>
    </div>
  </div>
</section>
